/**
 * Created by Vladislav on 05.12.2025.
 */

const PointerManager = function () {
    this.handlers = new Set();
};

PointerManager.prototype.create = function (target, options) {
    const handler = new PointerHandler(target, options);

    this.handlers.add(handler);

    target.addCleaner(this.remove.bind(this, handler));

    cleverapps.inputDispatcher.markHandlersDirty();

    return handler;
};

PointerManager.prototype.remove = function (handler) {
    if (this.handlers.has(handler)) {
        this.handlers.delete(handler);

        handler.destructor();

        cleverapps.inputDispatcher.markHandlersDirty();
    }
};

PointerManager.prototype.removeAll = function (target, recursive) {
    this.handlers.forEach((handler) => {
        if (handler.target === target) {
            this.remove(handler);
        }
    });

    if (recursive && target.children) {
        for (let i = 0; i < target.children.length; i++) {
            this.removeAll(target.children[i], true);
        }
    }
};

PointerManager.prototype.listHandlersForTarget = function (target) {
    return Array.from(this.handlers).filter((handler) => handler.target === target);
};